// modifer: styles/jss/nextjs-material-kit-pro/pages/aboutUsStyle.js
import { page, main, section, container, title } from 'styles/jss/original/base';

const styles = {
  page,
  section: {
    ...section,
    padding: '80px 0 40px',
    '@media (min-width: 1024px)': {
      padding: '60px 0 40px'
    },
    '@media (max-width: 992px)': {
      padding: '60px 0 30px'
    },
    '@media (max-width: 640px)': {
      padding: '40px 0 20px'
    }
  },
  main,
  container,
  title,
  titleLevel2: {
    ...title,
    textAlign: 'center',
    fontSize: '2.25rem',
    marginBottom: '50px',
    '@media (max-width: 640px)': {
      fontSize: '1.8rem',
      marginBottom: '30px',
      marginTop: '20px'
    },
    '@media (max-width: 320px)': {
      fontSize: '1.6rem'
    }
  }
};

export default styles;
